import * as React from "react";
import type { SVGProps } from "react";
const SvgCardCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M13.8 18.9H4.2a2.4 2.4 0 0 1-2.4-2.4v-9a2.4 2.4 0 0 1 2.4-2.4h14.4A2.4 2.4 0 0 1 21 7.5v4.2m-3.6 4.783 1.508 1.508L22.2 14.7M2.4 9.3h18"
    />
  </svg>
);
export default SvgCardCheck;
